// extracted by mini-css-extract-plugin
export var container = "MoreSalesList-module--container--27fb3";
export var heading = "MoreSalesList-module--heading--87338";
export var label = "MoreSalesList-module--label--07621";
export var list = "MoreSalesList-module--list--e5c06";
export var paddedItemsList = "MoreSalesList-module--paddedItemsList--842bf";